import {Injectable} from '@angular/core';
import {ISearchParams, sitesSearchParamsStore} from './sites-search-params.store';
import {LocalStorage} from '../../../decorators/local-storage.decorator';
import {UwV2SitesSearchListParams} from '../../../../userway/sdk/UserWayApiClient';

@Injectable({providedIn: 'root'})
export class SitesSearchParamsManager {
  // params that can be used with any other params
  COMMON_PARAMS = ['p', 'q', 's', 'status', 'isPdfRequest', 'type'];
  @LocalStorage('10') sitesPerPage: number;

  updateActiveSitesSearchParams(searchParams: UwV2SitesSearchListParams) {
    sitesSearchParamsStore.update(state => {
      return {
        ...state,
        ...this.getUpdateSitesPagination(state, searchParams),
        activeSitesSearchParams: this.validateSearchParams(state.activeSitesSearchParams, searchParams),
      };
    });
  }

  updateDeletedSitesSearchParams(searchParams: UwV2SitesSearchListParams) {
    sitesSearchParamsStore.update(state => ({
      ...state,
      ...this.getUpdateSitesPagination(state, searchParams),
      deletedSitesSearchParams: this.validateSearchParams(state.deletedSitesSearchParams, searchParams),
    }));
  }

  updateReviewedSitesSearchParams(searchParams: UwV2SitesSearchListParams) {
    sitesSearchParamsStore.update(state => ({
      ...state,
      ...this.getUpdateSitesPagination(state, searchParams),
      reviewedSitesSearchParams: this.validateSearchParams(state.reviewedSitesSearchParams, searchParams),
    }));
  }

  updatePdfSitesSearchParams(searchParams: UwV2SitesSearchListParams) {
    sitesSearchParamsStore.update(state => ({
      ...state,
      ...this.getUpdateSitesPagination(state, searchParams),
      pdfSitesSearchParams: this.validateSearchParams(state.pdfSitesSearchParams, searchParams),
    }));
  }

  resetAll() {
    sitesSearchParamsStore.reset();
  }

  private validateSearchParams(
    previousParamsState: UwV2SitesSearchListParams,
    searchParams: UwV2SitesSearchListParams,
  ): UwV2SitesSearchListParams {
    return {
      // Retain sorting such as by url, date etc. if only common params changed
      ...(this.isOnlyCommonParams(searchParams) ? previousParamsState : {}),
      ...this.getExistedCommonParams(previousParamsState),
      ...searchParams,
    };
  }

  private getUpdateSitesPagination(state: ISearchParams, searchParams: UwV2SitesSearchListParams) {
    return {
      sitesPagination: {
        ...state.sitesPagination,
        ...(searchParams.p ? {p: searchParams.p} : {}),
        ...(searchParams.q ? {q: searchParams.q} : {}),
      },
    };
  }

  private isOnlyCommonParams(searchParams: UwV2SitesSearchListParams) {
    let isOnlyCommon = false;

    for (const searchParamsKey in searchParams) {
      if (this.COMMON_PARAMS.includes(searchParamsKey)) {
        isOnlyCommon = true;
      } else {
        return false;
      }
    }

    return isOnlyCommon;
  }

  private getExistedCommonParams(previousParamsState: UwV2SitesSearchListParams) {
    return this.COMMON_PARAMS.reduce((foundCommonParams, currentParam) => {
      const currentParamObj = previousParamsState.hasOwnProperty(currentParam)
        ? {[currentParam]: previousParamsState[currentParam]}
        : {};

      return {
        ...foundCommonParams,
        ...currentParamObj,
      };
    }, {});
  }
}
